const AddIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0397 4.45827C14.6446 3.84724 17.3555 3.84724 19.9604 4.45827C23.7222 5.34066 26.6594 8.2779 27.5418 12.0397C28.1528 14.6446 28.1528 17.3555 27.5418 19.9604C26.6594 23.7222 23.7222 26.6594 19.9604 27.5418C17.3555 28.1528 14.6446 28.1528 12.0397 27.5418C8.2779 26.6594 5.34066 23.7222 4.45827 19.9604C3.84724 17.3555 3.84724 14.6446 4.45827 12.0397C5.34066 8.2779 8.2779 5.34066 12.0397 4.45827ZM16.8 12.809C16.8 12.3672 16.4418 12.009 16 12.009C15.5582 12.009 15.2 12.3672 15.2 12.809V15.2H12.809C12.3672 15.2 12.009 15.5582 12.009 16C12.009 16.4418 12.3672 16.8 12.809 16.8H15.2V19.191C15.2 19.6328 15.5582 19.991 16 19.991C16.4418 19.991 16.8 19.6328 16.8 19.191V16.8H19.191C19.6328 16.8 19.991 16.4418 19.991 16C19.991 15.5582 19.6328 15.2 19.191 15.2H16.8V12.809Z"
        fill="#62AA48"
      />
    </svg>
  );
};

export default AddIcon;
